// components/Projects.js
import React from 'react';
import { motion } from 'framer-motion';
import ghck from '../assets/ghck.png';
import wwc from '../assets/wwc.png';
import ember from '../assets/ember.png';
import long from '../assets/long.png';
import septa from '../assets/septa.png';
import zivuko from '../assets/zivuko.png';
import comm from '../assets/comm.png';
import web from '../assets/web.png';
import book from '../assets/book.jpeg';
import robot from '../assets/ros.jpeg';
import doba from '../assets/doba.jpeg';

const Projects = () => {
  const projects = [
    {
      title: 'Bookie 1.0 - Learning Management System',
      description:
        'A full-stack learning management mobile app with Express, Node.js, React, and MongoDB. Integrated M-Pesa Daraja for payments and Node mailer for email activation.',
      technologies: ['React', 'Node.js', 'Express', 'MongoDB', 'M-Pesa API'],
      period: 'Jan 2025 - Apr 2025',
      category: 'Mobile App',
      image: `${book}`,
    },
    {
      title: 'E-Commerce Web Application',
      description:
        'Developed a full-stack e-commerce system with Express, Node.js, React, and MongoDB. Used TailwindCSS for styling.',
      technologies: ['React', 'Node.js', 'Express', 'MongoDB', 'TailwindCSS'],
      period: 'Jun 2024 - Jul 2024',
      category: 'Web App',
      image: `${comm}`,
    },
    {
      title: 'Doba Music App',
      description:
        'A music player mobile app developed with Express, Node.js, React, and MongoDB using agile methodology.',
      technologies: ['React', 'Node.js', 'Express', 'MongoDB'],
      period: 'Jun 2024 - Jul 2024',
      category: 'Mobile App',
      image: `${doba}`,
    },
    {
      title: 'Gulf Medical Management System',
      description:
        'A full-stack medical management web system for healthcare facilities.',
      technologies: ['React', 'Node.js', 'Express', 'MongoDB', 'TailwindCSS'],
      period: 'Oct 2024 - Present',
      category: 'Web App',
      image: `${ghck}`,
      link: 'https://www.ghck.co.ke',
    },
    {
      title: 'Web Achievers Portfolio',
      description:
        'Designed a web portfolio for a youth empowerment organization with React and Node.js.',
      technologies: ['React', 'Node.js', 'CSS'],
      period: 'Jun 2024 - Jul 2024',
      category: 'Web Design',
      image: `${web}`,
    },
    {
      title: 'Robotics Programming with ROS',
      description:
        'Collaborated on the design and programming of robots using ROS (Robot Operating System).',
      technologies: ['ROS', 'Python', 'C++'],
      period: '2024',
      category: 'Robotics',
      image: `${robot}`,
    },
    {
      title: 'William Writes Code Portfolio',
      description:
        'Designed a personal web portfolio for personal branding with React and Node.js.',
      technologies: ['React', 'Node.js', 'CSS'],
      period: 'Jul 2025',
      category: 'Web Design',
      image: `${wwc}`,
    },
        {
      title: 'Emberprise Africa Website',
      description:
        'Designed a website for Emberprise Africa with Next.js and Node.js.',
      technologies: ['Next.js', 'Node.js', 'Tailwind CSS'],
      period: 'Jun 2024 - Jul 2024',
      category: 'Web Design',
      image: `${ember}`,
      link: 'https://emberprise.netlify.app/',
    },
        {
      title: 'Longclause Website',
      description:
        'Designed a website for LongClause with Next.js and Node.js.',
      technologies: ['Next.js', 'Node.js', 'Tailwind CSS'],
      period: 'Jun 2024 - Jul 2024',
      category: 'Web Design',
      image: `${long}`,
    },
        {
      title: 'SeptaGreen Africa Website',
      description:
        'Designed a website for SeptaGreen Africa with Next.js and Node.js.',
      technologies: ['Next.js', 'Node.js', 'Tailwind CSS'],
      period: 'Jun 2025 - Jul 2025',
      category: 'Web Design',
      image: `${septa}`,
    },
        {
      title: 'Zivuko Kenya Website',
      description:
        'Designed an e-commerce site for Zivuko with Next.js and Node.js.',
      technologies: ['Next.js', 'Node.js', 'Tailwind CSS'],
      period: 'May 2024 - present',
      category: 'Web Design',
      image: `${zivuko}`,
    },
  ];

  return (
    <section
      id="projects"
      className="section bg-[#f4f3ee] py-16 dark:bg-black"
    >
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="section-title text-gray-900 dark:text-white">
            Featured <span className="brand-accent">Projects</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg leading-snug tracking-[-0.025em] text-gray-600 dark:text-gray-400">
            Web, mobile, robotics, and business systems built across client,
            startup, and product work.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="brand-card-accent group overflow-hidden rounded-lg border bg-[#fbfaf6] transition-all duration-300 hover:-translate-y-1 dark:bg-[#131416]"
            >
              <div className="relative h-52 overflow-hidden border-b border-black/10 dark:border-white/10">
                <img
                  src={project.image}
                  alt={project.title}
                  className="h-full w-full object-cover grayscale transition-transform duration-500 group-hover:scale-105 group-hover:grayscale-0"
                />
                <div className="absolute left-3 top-3 rounded-full bg-[var(--brand-blue)] px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-white">
                  {project.category}
                </div>
              </div>

              <div className="p-6">
                <h3 className="mb-3 text-2xl font-normal leading-none tracking-[-0.05em] text-gray-900 transition-colors group-hover:text-[var(--brand-blue)] dark:text-white dark:group-hover:text-[#8fb7ff]">
                  {project.title}
                </h3>

                <p className="mb-4 text-sm leading-snug text-gray-600 dark:text-gray-400">
                  {project.description}
                </p>

                <div className="mb-4">
                  <div className="mb-2 text-[10px] font-semibold uppercase tracking-[0.16em] text-gray-500 dark:text-gray-400">
                    Technologies:
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {project.technologies.map((tech, i) => (
                      <span
                        key={i}
                        className={`rounded-full border px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] ${i % 2 === 0 ? "brand-chip" : "brand-chip-green"}`}
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-500 dark:text-gray-400">
                    {project.period}
                  </span>
                  {project.link && (
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center text-sm font-semibold text-[var(--brand-blue)] hover:text-[var(--brand-green)] dark:text-[#8fb7ff] dark:hover:text-[#74c78c]"
                    >
                      <i className="bx bx-link-external mr-1"></i> View Live
                    </a>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
